import { BaseService } from "./base.service";
import { loadavg } from "os";
import { MODE } from "../reducers/mode.reducer";
import { PencilModeAdapter } from "../adapters/pencilMode.adapter";

export class FlowService extends BaseService {
  constructor(_hostName, _flowId) {
    super(_hostName);
    this.flowId = _flowId;
  }

  readFlow() {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await this.makeGetRequest(
          "einsclass/flowItem/" + this.flowId
        );
        return resolve(result.data.flowItem);
      } catch (error) {
        reject(error);
      }
    });
  }

  pushToServer(data, id, type, flowId, classId, selectedPageId) {
    // TODO HANDLE OTHER TYPES HERE
    const pencilModeAdapter = new PencilModeAdapter();
    let server = pencilModeAdapter.getServer(
      data,
      id,
      type,
      flowId,
      classId,
      selectedPageId
    );

    this.emitData("message", JSON.stringify(server));
  }

  removeFromServer(flowId, itemId) {
    this.emitData(
      "message",
      JSON.stringify({ flowId, elementId: itemId, type: "remove" })
    );
  }

  removeMultipleFromServer(flowId, itemIds) {
    itemIds.forEach(itemId => {
      this.removeFromServer(flowId, itemId);
    });
  }
}
